// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"8416fee6","209":"c61446d1","829":"a40e8624","878":"817f85f4"}[chunkId] + ".chunk.js";
};